module.exports = __webpack_public_path__ + "img/9788996623717.531d24b6.jpg";